
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import ContactUs from '@/components/ContactUs';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
// Dedicated Contact Us page. The form used to be inlined at the bottom of
// every marketing page (home, pricing, templates, TTS…); it now lives here
// so the Turnstile widget and its script load only for people who actually
// want to write to us. Old `/#contact-us` links redirect from the homepage.
export default function ContactPage() {
    const { t } = useLocale('contact');
    return (<main className='flex min-h-screen flex-col bg-white dark:bg-slate-900'>
      <Seo templateTitle={t('Contact Us')} description={t('Please use the form below to contact us. Thank you!')}/>
      <LandingPageNavigation />
      <div className='flex-1 pt-16 sm:pt-24'>
        <ContactUs />
      </div>
      <Footer />
    </main>);
}
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a13a29a105__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a105__ as getStaticProps }
  